document.addEventListener('click', function (e) {
  var link = e.target.closest('a[href^="/collections/"]');
  if (!link) return;
  if (link.href.indexOf('#products-start') !== -1) return;
  var carousel = link.closest('[data-testid="collections-list-grid"]');
  if (carousel) {
    e.preventDefault();
    window.location.href = link.href + '#products-start';
  }
});